import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Paper, Typography, Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';

const DraftsTable = ({ books, handleEditBook, handleEditBookWithNewSelection, handleDeleteBook, handlePrintBook }) => {
  return (
    <Box sx={{ ml: '1rem', mr: '1rem', mb: '2rem' }}>
      {books.length > 0 ? (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Schullogbuch</TableCell>
                <TableCell>Bearbeiten</TableCell>
                <TableCell>Bearbeiten mit erneuter Auswahl</TableCell>
                <TableCell>Löschen</TableCell>
                <TableCell>Überprüfungsansicht & Bestellung</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {books
              .slice() // Erst eine Kopie erstellen, um den ursprünglichen State nicht zu verändern
              .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)) // Nach `updatedAt` sortieren (neueste zuerst)
              .map((book) => (
                <TableRow key={book._id}>
                  <TableCell>{book.name}</TableCell>
                  <TableCell>
                    <IconButton color="primary" sx={{ color: 'primary.light' }} onClick={() => handleEditBook(book._id)}>
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleEditBookWithNewSelection(book._id, book.name)}>
                      <EditIcon color="secondary" sx={{ color: 'secondary.light' }}/>
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleDeleteBook(book._id)}>
                      <DeleteIcon color="error" sx={{ color: 'error.light' }}/>
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => handlePrintBook(book._id)}>
                      <VisibilityIcon color="success" sx={{ color: 'success.light' }}/>
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="body1" color="textSecondary" style={{ marginTop: '20px' }}>
          Keine Entwürfe verfügbar. Erstellen Sie ein neues Schullogbuch.
        </Typography>
      )}
    </Box>
  );
};

export default DraftsTable;